module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_34.578b0a12.png";